"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sihuaLu: '祿',
    sihuaQuan: '權',
    sihuaKe: '科',
    sihuaJi: '忌',
};
